export default "__VITE_ASSET__CkXjFB6K__"